<ion-header>
  <ion-toolbar id="scanner-toolbar">
    <ion-buttons slot="end">
      <ion-button color="secondary" (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="!mobileView">  
    <zxing-scanner *ngIf="scannerEnabled" #scanner (scanSuccess)="scanSuccessHandler($event)">
    </zxing-scanner>  
</ion-content>

<ion-content *ngIf="mobileView" class="camera-view">


</ion-content>


